import { inRange, orderBy } from 'lodash'

const getPreAvaliatedSupplierByCompliance = (
  supplierStats,
  complianceMin,
  complianceMax,
  order = 'desc',
) => {
  const suppliers = supplierStats?.preAvaliatedSuppliers?.filter((supplier) =>
    inRange(supplier?.compliance, complianceMin, complianceMax + 0.001),
  )
  return orderBy(suppliers, ['compliance'], [order])
}

export default getPreAvaliatedSupplierByCompliance
